module.exports = __webpack_public_path__ + "img/title-promotions.446e205.webp";